<template>
  <div class="product-buy-field">
    <label :for="id">{{ label }}</label>
    <div class="product-buy-select-wrap">
      <select :id="id" :name="id" :value="modelValue" @change="onChange">
        <option v-for="option in options" :key="option.value" :value="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>
    <p v-if="note" class="product-buy-fields_select-note">{{ note }}</p>
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `product-buy-field`（購入枠の中のセレクト1つ）。
 * 「数量」と「お届けの間隔」で使う。支給は `product-buy-select-wrap` が矢印を描くので、
 * `<select>` はその中に置く。
 *
 * **選択肢は API から作る（ハードコード禁止・§3.7）。**
 * - 通常購入の数量 … `lowerLimit`〜`upperLimit`（全38商品が 1〜30）
 * - 定期の数量 … `quantityThresholdCodes` を持つ7商品（`210` `501` `520` `530` `592` `810` `710`）は
 *   その `lowerLimit`/`upperLimit`、それ以外の定期商品は `regularMinQuantity`/`regularMaxQuantity`
 * - お届けの間隔 … 同じく threshold を持つ商品は `availableCycles`（数量帯ごとに変わる）、
 *   それ以外は `regularCycle`（決定#47 の訂正）
 *
 * **`K41`〜`K45` の5商品はセレクタが3本立て**（色を選択／数量／フレーバー。
 * `design-src/20260810/product-detail/productK41.html:458,472,489`）。色とフレーバーの選択肢は
 * API ではなく既存 `src/consts/ProductConst.ts` の `PRODUCT_CONSTANTS.KENCOS.COMBINATION_MAP`
 * （`:18-34`。色×フレーバー→商品コードの15通り）と `SERIES_CODE`（`:35`）に対応する。
 * この部品は選択肢を props で受けるので、KENCOS でもそのまま使える。
 *
 * `id` は支給が `regular_qty` / `normal_qty` / `regular_interval` を使っており、
 * `<label for>` と対にする必要があるため必須にする。
 * → CONVERSION-GUIDE.md §3.3.1 の #6 ／ §3.3.2
 */
type Option = {
  value: string | number;
  label: string;
};

type Props = {
  /** `<select>` の id。`<label for>` と対にする */
  id: string;
  label: string;
  options: Option[];
  modelValue: string | number;
  /** セレクトの右に出す補足。支給は「/1回あたり」 */
  note?: string;
};

defineProps<Props>();

const emit = defineEmits<{ 'update:modelValue': [value: string] }>();

const onChange = (event: Event): void => {
  emit('update:modelValue', (event.target as HTMLSelectElement).value);
};
</script>
